import React, { useEffect, useState, useRef } from "react";
import Topbar from "../components/Topbar";
import Sidebar from "../components/Sidebar";
import styles from "../assets/css/Pdfsection.module.css";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft, FaCheck, FaEdit, FaEye, FaPlus } from "react-icons/fa";
import { Modal } from "react-bootstrap";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";

// Robust date parser for DD-MM-YY and DD-MM-YYYY
const parseDate = (str) => {
  if (!str) return null;
  const [day, month, year] = str.split("-");
  if (!day || !month || !year) return null;
  let fullYear = year;
  if (year.length === 2) {
    fullYear = "20" + year;
  }
  return new Date(`${fullYear}-${month}-${day}`);
};

function PdfSection() {
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [reportPeriod, setReportPeriod] = useState({ start: "", end: "" });
  const [pdfData, setPdfData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [processingHistory, setProcessingHistory] = useState([]);
  const [selectedMemoNo, setSelectedMemoNo] = useState("");
  const [historyLoading, setHistoryLoading] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    memo_no: "",
    memo_date: "",
    name_of_works: "",
    boc: null,
    alotment: "",
    alotment_amount: "",
    work_order_memo_no: "",
    work_order_date: "",
    // start
    engence_agency: "",
    estimet_amount: "",
    less_amount: "",
    above_amount: "",
    final_amount: "",
    date_of_agreement: "",
    duration: "",
    date_of_commencement: "",
    date_of_completion: "",
    name_of_concerned_sae: "",
    department_date: "",
    department: "",
    physical_status: "",
    final_payment_amount: "",
    unspent_balance: "",
    remarks: "",
  });
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [statusFormData, setStatusFormData] = useState({
    date: "",
    department: "",
    type: "",
  });
  const tableRef = useRef();

  useEffect(() => {
    // const department = JSON.parse(localStorage.getItem("department"));
    // if (department !== "pwd") {
    //   navigate("/departmentlogin");
    // }
    const fetchPdfData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/hfa_list`
        );
        const data = await response.json();
        setPdfData(data.hfa_list);
        setFilteredData(data.hfa_list);
      } catch (error) {
        console.error("Error fetching PDF data:", error);
      }
      setLoading(false);
    };
    fetchPdfData();
    return () => {
      if ($.fn.DataTable.isDataTable("#pdfTable")) {
        $("#pdfTable").DataTable().destroy();
      }
    };
  }, [navigate]);

  useEffect(() => {
    if (!loading && filteredData.length > 0) {
      $("#pdfTable").DataTable({
        responsive: true,
        pageLength: 10,
        lengthMenu: [
          [10, 25, 50, -1],
          [10, 25, 50, "All"],
        ],
        order: [[1, "desc"]],
        language: {
          search: "Search:",
          lengthMenu: "Show _MENU_ entries",
          info: "Showing _START_ to _END_ of _TOTAL_ entries",
          infoEmpty: "Showing 0 to 0 of 0 entries",
          infoFiltered: "(filtered from _MAX_ total entries)",
          paginate: {
            first: "First",
            last: "Last",
            next: "Next",
            previous: "Previous",
          },
        },
      });
    }
    return () => {
      if ($.fn.DataTable.isDataTable("#pdfTable")) {
        $("#pdfTable").DataTable().destroy();
      }
    };
  }, [filteredData, loading]);

  const handleFilter = () => {
    if (!startDate || !endDate) return;
    if ($.fn.DataTable.isDataTable("#pdfTable")) {
      $("#pdfTable").DataTable().destroy();
    }
    const start = new Date(startDate);
    const end = new Date(endDate);
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);
    const filtered = pdfData.filter((item) => {
      const memoDate = parseDate(item.memo_date);
      if (!memoDate || isNaN(memoDate)) return false;
      memoDate.setHours(0, 0, 0, 0);
      return memoDate >= start && memoDate <= end;
    });
    setFilteredData(filtered);
    setReportPeriod({ start: startDate, end: endDate });
  };

  const handleReset = () => {
    setStartDate("");
    setEndDate("");
    setReportPeriod({ start: "", end: "" });
    setFilteredData(pdfData);
  };

  //   start

  const handleProcessingHistory = async (id, memoNo) => {
    setSelectedMemoNo(memoNo);
    setShowModal(true);
    setHistoryLoading(true);
    try {
      const formData = new FormData();
      formData.append("hfa_id", id);
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/hfa_history`,
        {
          method: "POST",
          body: formData,
        }
      );
      const data = await response.json();
      setProcessingHistory(data.history_list);
    } catch (error) {
      console.error("Error fetching processing history:", error);
    }
    setHistoryLoading(false);
  };

  // end

  const closeModal = () => {
    setShowModal(false);
    setProcessingHistory([]);
    setSelectedMemoNo("");
  };

  const handleChangeStatus = (id, memoNo) => {
    setSelectedId(id);
    setSelectedMemoNo(memoNo);
    setShowStatusModal(true);
  };

  const handleStatusChange = (e) => {
    const { name, value } = e.target;
    setStatusFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleStatusSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("hfa_id", selectedId);
      formData.append("memo_no", selectedMemoNo);
      formData.append("department_date", statusFormData.date);
      formData.append("department", statusFormData.department);
      formData.append("type", statusFormData.type);

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/UpdatetHFA`,
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      if (data.code === 0) {
        alert(data.message);
      } else {
        // Refresh the data
        const updatedResponse = await fetch(
          `${process.env.REACT_APP_API_URL}/hfa_list`
        );
        const updatedData = await updatedResponse.json();
        setPdfData(updatedData.hfa_list);
        setFilteredData(updatedData.hfa_list);
        setShowStatusModal(false);
        setStatusFormData({
          date: "",
          department: "",
          type: "",
        });
      }
    } catch (error) {
      console.error("Error updating status:", error);
      alert("Error updating status. Please try again.");
    }
  };

  const handleEdit = async (id) => {
    try {
      // Find the row data from the filteredData array
      const rowData = filteredData.find((item) => item.id === id);
      if (rowData) {
        setFormData({
          memo_no: rowData.memo_no || "",
          memo_date: rowData.memo_date || "",
          name_of_works: rowData.name_of_works || "",
          boc: rowData.boc || null,
          alotment: rowData.alotment || "",
          alotment_amount: rowData.alotment_amount || "",
          work_order_memo_no: rowData.work_order_memo_no || "",
          work_order_date: rowData.work_order_date || "",

          engaged_agency: rowData.engaged_agency || "",
          estimate_amount: rowData.estimate_amount || "",
          less_amount: rowData.less_amount || "",
          above_amount: rowData.above_amount || "",
          final_amount: rowData.final_amount || "",
          date_of_agreement: rowData.date_of_agreement || "",
          duration: rowData.duration || "",
          date_of_commencement: rowData.date_of_commencement || "",
          date_of_completion: rowData.date_of_completion || "",
          name_of_concerned_sae: rowData.name_of_concerned_sae || "",
          department_date: rowData.department_date || "",
          department: rowData.department || "",
          physical_status: rowData.physical_status || "",
          final_payment_amount: rowData.final_payment_amount || "",
          unspent_balance: rowData.unspent_balance || "",
          remarks: rowData.remarks || "",
        });
        setIsEditMode(true);
        setEditingId(id);
        setShowAddModal(true);
      }
    } catch (error) {
      console.error("Error preparing data for edit:", error);
      alert("Error preparing data for edit. Please try again.");
    }
  };

  const handleAddNewChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
  };

  const handleAddNewSubmit = async (e) => {
    e.preventDefault();
    try {
      const formDataToSend = new FormData();

      // Add the HFA ID for update operation
      if (isEditMode) {
        formDataToSend.append("hfa_id", editingId);
      }

      Object.keys(formData).forEach((key) => {
        if (key === "boc" && formData[key]) {
          formDataToSend.append("boc", formData[key]);
        } else {
          formDataToSend.append(key, formData[key]);
        }
      });

      const url = isEditMode
        ? `${process.env.REACT_APP_API_URL}UpdatetHFA`
        : `${process.env.REACT_APP_API_URL}/PostHFA`;

      const method = isEditMode ? "POST" : "POST";

      const response = await fetch(url, {
        method: method,
        body: formDataToSend,
      });

      const data = await response.json();

      if (data.code === 0) {
        alert(data.message);
      } else {
        const updatedResponse = await fetch(
          `${process.env.REACT_APP_API_URL}/hfa_list`
        );
        const updatedData = await updatedResponse.json();
        setPdfData(updatedData.hfa_list);
        setFilteredData(updatedData.hfa_list);
        setShowAddModal(false);
        setIsEditMode(false);
        setEditingId(null);
        setFormData({
          memo_no: "",
          memo_date: "",
          name_of_works: "",
          boc: null,
          alotment: "",
          alotment_amount: "",
          work_order_memo_no: "",
          work_order_date: "",
          // start
          engence_agency: "",
          estimet_amount: "",
          less_amount: "",
          above_amount: "",
          final_amount: "",

          // end

          // work_order_agency: "",
          // work_value: "",
          date_of_agreement: "",
          duration: "",
          date_of_commencement: "",
          date_of_completion: "",
          name_of_concerned_sae: "",
          department_date: "",
          department: "",
          physical_status: "",
          final_payment_amount: "",
          unspent_balance: "",
          remarks: "",
        });
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      alert("Error submitting data. Please try again.");
    }
  };

  return (
    <>
      <Topbar />
      <div className="d-flex">
        <Sidebar />
        <div className={styles.tableContainer} style={{ width: "100%" }}>
          <div className="d-flex align-items-center mb-4">
            <button
              className="btn btn-link text-primary p-0 me-3"
              onClick={() => navigate("/pwdsection")}
              style={{ textDecoration: "none" }}
            >
              <FaArrowLeft className="me-1" />
              Back
            </button>
            <h2
              className="mb-0"
              style={{
                color: "#2c3e50",
                fontWeight: "500",
                fontSize: "1.5rem",
              }}
            >
              PWD Documents
            </h2>
          </div>
          <div
            className="card mb-4"
            style={{ borderRadius: "8px", backgroundColor: "#fff" }}
          >
            <div className="card-body p-3">
              <div className="d-flex justify-content-between align-items-start mb-3">
                <div className="row g-3 align-items-end flex-grow-1">
                  <div className="col-auto">
                    <label className="form-label small text-muted mb-1">
                      Start Date
                    </label>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      style={{ width: "160px", borderColor: "#dee2e6" }}
                    />
                  </div>
                  <div className="col-auto">
                    <label className="form-label small text-muted mb-1">
                      End Date
                    </label>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      style={{ width: "160px", borderColor: "#dee2e6" }}
                    />
                  </div>
                  <div className="col-auto">
                    <button
                      className="btn btn-primary btn-sm px-4"
                      onClick={handleFilter}
                      disabled={!startDate || !endDate}
                    >
                      Apply Filter
                    </button>
                    <button
                      className="btn btn-outline-secondary btn-sm px-3 ms-2"
                      onClick={handleReset}
                    >
                      Reset
                    </button>
                  </div>
                </div>
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => setShowAddModal(true)}
                >
                  <FaPlus /> Add New
                </button>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body p-0">
              <div className="table-responsive">
                <table
                  ref={tableRef}
                  id="pdfTable"
                  className="table mb-0"
                  style={{ borderCollapse: "collapse" }}
                >
                  <thead>
                    <tr className="bg-light">
                      <th
                        style={{
                          padding: "12px 16px",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          color: "#495057",
                          width: "100px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Memo No
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          color: "#495057",
                          width: "100px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Memo Date
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          color: "#495057",
                          width: "150px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Name of Works
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          color: "#495057",
                          width: "100px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        BOC
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          color: "#495057",
                          width: "100px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Alotment(Head)
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          color: "#495057",
                          width: "120px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Alotment Amount
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          color: "#495057",
                          width: "120px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Work Order Memo No
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          color: "#495057",
                          width: "120px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Work Order Date
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          color: "#495057",
                          width: "120px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Engaged Agency
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          color: "#495057",
                          width: "120px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Estimate Amount
                      </th>

                      <th
                        style={{
                          padding: "12px 16px",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          color: "#495057",
                          width: "100px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Finnal Value
                      </th>

                      <th
                        style={{
                          padding: "12px 16px",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          color: "#495057",
                          width: "120px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Date of Agreement
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          color: "#495057",
                          width: "100px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Duration
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          color: "#495057",
                          width: "150px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Date of Commencement
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          color: "#495057",
                          width: "120px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Date of Completion
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          color: "#495057",
                          width: "150px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Name of Concerned SAE
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          color: "#495057",
                          width: "150px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Processing Date
                      </th>

                      <th
                        style={{
                          padding: "12px 16px",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          color: "#495057",
                          width: "120px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Department
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          color: "#495057",
                          width: "120px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Physical Status
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          color: "#495057",
                          width: "120px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Final Payment Amount
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          color: "#495057",
                          width: "120px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Unspent Balance
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          color: "#495057",
                          width: "120px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Remarks
                      </th>

                      <th
                        style={{
                          padding: "12px 16px",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          color: "#495057",
                          width: "120px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Status
                      </th>

                      <th
                        style={{
                          padding: "12px 16px",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          color: "#495057",
                          width: "120px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        View
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          color: "#495057",
                          width: "120px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td
                          colSpan="22"
                          style={{ textAlign: "center", padding: "2rem" }}
                        >
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </td>
                      </tr>
                    ) : filteredData.length === 0 ? (
                      <tr>
                        <td
                          colSpan="22"
                          style={{
                            textAlign: "center",
                            padding: "2rem",
                            color: "#6c757d",
                            fontSize: "1rem",
                          }}
                        >
                          No data found for the selected date range
                        </td>
                      </tr>
                    ) : (
                      filteredData.map((row, index) => (
                        <tr key={index}>
                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                            }}
                          >
                            {row.memo_no}
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                            }}
                          >
                            {row.memo_date}
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                            }}
                          >
                            {row.name_of_works}
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                            }}
                          >
                            {row.boc}
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                            }}
                          >
                            {row.alotment}
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                            }}
                          >
                            {row.alotment_amount}
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                            }}
                          >
                            {row.work_order_memo_no}
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                            }}
                          >
                            {row.work_order_date}
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                            }}
                          >
                            {row.engence_agency}
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                            }}
                          >
                            {row.estimet_amount}
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                            }}
                          >
                            {row.final_amount}
                          </td>

                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                            }}
                          >
                            {row.date_of_agreement}
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                            }}
                          >
                            {row.duration}
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                            }}
                          >
                            {row.date_of_commencement}
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                            }}
                          >
                            {row.date_of_completion}
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                            }}
                          >
                            {row.name_of_concerned_sae}
                          </td>

                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                            }}
                          >
                            {row.department_date}
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                            }}
                          >
                            {row.department}
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                            }}
                          >
                            {row.physical_status}
                          </td>

                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                            }}
                          >
                            {row.final_payment_amount}
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                            }}
                          >
                            {row.unspent_balance}
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                            }}
                          >
                            {row.remarks}
                          </td>

                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                            }}
                          >
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() =>
                                handleProcessingHistory(row.id, row.memo_no)
                              }
                            >
                              status
                            </button>
                          </td>

                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                            }}
                          >
                            <button
                              style={{
                                backgroundColor: "#001a4d",
                                border: "none",
                              }}
                              className="btn btn-primary btn-sm"
                              onClick={() =>
                                handleProcessingHistory(row.id, row.memo_no)
                              }
                            >
                              view
                            </button>
                          </td>

                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                              width: "120px",
                              whiteSpace: "nowrap",
                              display: "flex",
                              gap: "10px",
                            }}
                          >
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() => handleEdit(row.id)}
                            >
                              <FaEdit />
                            </button>
                            <button
                              className="btn btn-info btn-sm"
                              onClick={() =>
                                handleChangeStatus(row.id, row.memo_no)
                              }
                            >
                              <FaEye />
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
              <div className="p-3 border-top">
                <p
                  className="mb-0 text-muted"
                  style={{
                    fontSize: "0.875rem",
                    borderLeft: "3px solid #007bff",
                    paddingLeft: "10px",
                  }}
                >
                  <i className="far fa-calendar-alt me-2"></i>
                  Report generated for the period: {reportPeriod.start ||
                    "-"}{" "}
                  to {reportPeriod.end || "-"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Processing History Modal */}
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Processing History - Memo No: {selectedMemoNo}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                {historyLoading ? (
                  <div className="text-center py-4">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : processingHistory?.length === 0 ? (
                  <div className="text-center py-4 text-muted">
                    No processing history found
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                              fontWeight: "500",
                              color: "#495057",
                            }}
                          >
                            SL
                          </th>
                          <th
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                              fontWeight: "500",
                              color: "#495057",
                            }}
                          >
                            Department Date
                          </th>
                          <th
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                              fontWeight: "500",
                              color: "#495057",
                            }}
                          >
                            Department
                          </th>
                          <th
                            style={{
                              padding: "12px 16px",
                              fontSize: "0.875rem",
                              fontWeight: "500",
                              color: "#495057",
                            }}
                          >
                            Type
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {processingHistory?.map((history, index) => (
                          <tr key={index}>
                            <td
                              style={{
                                padding: "12px 16px",
                                fontSize: "0.875rem",
                              }}
                            >
                              {index + 1}
                            </td>
                            <td
                              style={{
                                padding: "12px 16px",
                                fontSize: "0.875rem",
                              }}
                            >
                              {history.department_date}
                            </td>
                            <td
                              style={{
                                padding: "12px 16px",
                                fontSize: "0.875rem",
                              }}
                            >
                              {history.department}
                            </td>
                            <td
                              style={{
                                padding: "12px 16px",
                                fontSize: "0.875rem",
                              }}
                            >
                              {history.type}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add New Large Modal */}
      {showAddModal && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header" style={{ padding: "12px 20px" }}>
                <h5
                  className="modal-title"
                  style={{
                    color: "#2c3e50",
                    fontWeight: 500,
                    fontSize: "1.2rem",
                  }}
                >
                  {isEditMode ? "Edit Document" : "Add New File"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowAddModal(false);
                    setIsEditMode(false);
                    setEditingId(null);
                    setFormData({
                      memo_no: "",
                      memo_date: "",
                      name_of_works: "",
                      boc: null,
                      alotment: "",
                      alotment_amount: "",
                      work_order_memo_no: "",
                      work_order_date: "",
                      // start
                      engence_agency: "",
                      estimet_amount: "",
                      less_amount: "",
                      above_amount: "",
                      final_amount: "",

                      // end

                      // work_order_agency: "",
                      // work_value: "",
                      date_of_agreement: "",
                      duration: "",
                      date_of_commencement: "",
                      date_of_completion: "",
                      name_of_concerned_sae: "",
                      department_date: "",
                      department: "",
                      physical_status: "",
                      final_payment_amount: "",
                      unspent_balance: "",
                      remarks: "",
                    });
                  }}
                ></button>
              </div>

              <form onSubmit={handleAddNewSubmit}>
                <div
                  className="modal-body"
                  style={{ padding: "18px 20px 10px 20px" }}
                >
                  <div className="container-fluid">
                    <div className="row g-2">
                      <span style={{ color: "red" }}>
                        Type-NIQ/NIeQ/NIT/NIeT/EIO
                      </span>
                      <br></br>
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Memo No
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm mb-2"
                          name="memo_no"
                          value={formData.memo_no}
                          onChange={handleAddNewChange}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Memo Date
                        </label>
                        <input
                          type="date"
                          className="form-control form-control-sm mb-2"
                          name="memo_date"
                          value={formData.memo_date}
                          onChange={handleAddNewChange}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Name of Works
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm mb-2"
                          name="name_of_works"
                          value={formData.name_of_works}
                          onChange={handleAddNewChange}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "red", fontSize: "0.95rem" }}
                        >
                          Resolution copy of MCIC/BOC/Tender Committee
                        </label>
                        <input
                          type="file"
                          className="form-control form-control-sm mb-2"
                          name="boc"
                          onChange={handleAddNewChange}
                          accept="image/*"
                          required
                        />
                      </div>
                      {/* <div className="col-md-6">
                                                <label className="form-label fw-medium mb-1" style={{ color: '#495057', fontSize: '0.95rem' }}>Alotment <span style={{color:'red'}}>Head</span></label>
                                                <input type="text" className="form-control form-control-sm mb-2" name="alotment" value={formData.alotment} onChange={handleAddNewChange} />
                                            </div> */}
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Alotment <span style={{ color: "red" }}>Head</span>
                        </label>
                        <select
                          className="form-control form-control-sm mb-2"
                          name="alotment"
                          value={formData.alotment}
                          onChange={handleAddNewChange}
                        >
                          <option value="">--Select Alotment Head--</option>
                          <option value="Head1">Head 1</option>
                          <option value="Head2">Head 2</option>
                          <option value="Head3">Head 3</option>
                          {/* Add more options as needed */}
                        </select>
                      </div>

                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Alotment Amount
                        </label>
                        <input
                          type="number"
                          className="form-control form-control-sm mb-2"
                          name="alotment_amount"
                          value={formData.alotment_amount}
                          onChange={handleAddNewChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Work Order Memo No
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm mb-2"
                          name="work_order_memo_no"
                          value={formData.work_order_memo_no}
                          onChange={handleAddNewChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Work Order Date
                        </label>
                        <input
                          type="date"
                          className="form-control form-control-sm mb-2"
                          name="work_order_date"
                          value={formData.work_order_date}
                          onChange={handleAddNewChange}
                        />
                      </div>

                      <div className="col-md-4">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "red", fontSize: "0.95rem" }}
                        >
                          Engaged Agency
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm mb-2"
                          name="engence_agency"
                          value={formData.engence_agency}
                          onChange={handleAddNewChange}
                          required
                        />
                      </div>
                      <div className="col-md-2">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "red", fontSize: "0.95rem" }}
                        >
                          Estimet Amount
                        </label>
                        <input
                          type="number"
                          className="form-control form-control-sm mb-2"
                          name="estimet_amount"
                          value={formData.estimet_amount}
                          onChange={handleAddNewChange}
                          required
                        />
                      </div>

                      <div className="col-md-2">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "red", fontSize: "0.95rem" }}
                        >
                          Less(%)
                        </label>
                        <input
                          type="number"
                          className="form-control form-control-sm mb-2"
                          name="less_amount"
                          value={formData.less_amount}
                          onChange={handleAddNewChange}
                        />
                      </div>

                      <div className="col-md-2">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "red", fontSize: "0.95rem" }}
                        >
                          Above(%)
                        </label>
                        <input
                          type="number"
                          className="form-control form-control-sm mb-2"
                          name="above_amount"
                          value={formData.above_amount}
                          onChange={handleAddNewChange}
                        />
                      </div>

                      <div className="col-md-2">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "red", fontSize: "0.95rem" }}
                        >
                          Final Amount
                        </label>
                        <input
                          type="number"
                          className="form-control form-control-sm mb-2"
                          name="final_amount"
                          value={formData.final_amount}
                          onChange={handleAddNewChange}
                        />
                      </div>

                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Date of Agreement
                        </label>
                        <input
                          type="date"
                          className="form-control form-control-sm mb-2"
                          name="date_of_agreement"
                          value={formData.date_of_agreement}
                          onChange={handleAddNewChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Duration
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm mb-2"
                          name="duration"
                          value={formData.duration}
                          onChange={handleAddNewChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Date of Commencement
                        </label>
                        <input
                          type="date"
                          className="form-control form-control-sm mb-2"
                          name="date_of_commencement"
                          value={formData.date_of_commencement}
                          onChange={handleAddNewChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Date of Completion
                        </label>
                        <input
                          type="date"
                          className="form-control form-control-sm mb-2"
                          name="date_of_completion"
                          value={formData.date_of_completion}
                          onChange={handleAddNewChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Name of Concerned SAE
                        </label>
                        <select
                          className="form-control form-control-sm mb-2"
                          name="name_of_concerned_sae"
                          value={formData.name_of_concerned_sae}
                          onChange={handleAddNewChange}
                        >
                          <option value="">--Select SAE--</option>
                          <option value="SAE1">SAE 1</option>
                          <option value="SAE2">SAE 2</option>
                          <option value="SAE3">SAE 3</option>
                        </select>
                      </div>

                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "red", fontSize: "0.95rem" }}
                        >
                          Processing / Recieving Date
                        </label>
                        <input
                          type="date"
                          className="form-control form-control-sm mb-2"
                          name="department_date"
                          value={formData.department_date}
                          onChange={handleAddNewChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "red", fontSize: "0.95rem" }}
                        >
                          Send to
                        </label>
                        <select
                          className="form-control form-control-sm mb-2"
                          name="department"
                          value={formData.department}
                          onChange={handleAddNewChange}
                        >
                          <option value="">--Select Department--</option>
                          <option value="Civil">Civil</option>
                          <option value="Electrical">Electrical</option>
                          <option value="Mechanical">Mechanical</option>
                          <option value="IT">IT</option>
                        </select>
                      </div>

                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Physical Status
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm mb-2"
                          name="physical_status"
                          value={formData.physical_status}
                          onChange={handleAddNewChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Final Payment Amount
                        </label>
                        <input
                          type="number"
                          className="form-control form-control-sm mb-2"
                          name="final_payment_amount"
                          value={formData.final_payment_amount}
                          onChange={handleAddNewChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Unspent Balance
                        </label>
                        <input
                          type="number"
                          className="form-control form-control-sm mb-2"
                          name="unspent_balance"
                          value={formData.unspent_balance}
                          onChange={handleAddNewChange}
                        />
                      </div>
                      <div className="col-12">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Remarks
                        </label>
                        <textarea
                          className="form-control form-control-sm mb-2"
                          name="remarks"
                          value={formData.remarks}
                          onChange={handleAddNewChange}
                          rows={2}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer" style={{ padding: "10px 20px" }}>
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    onClick={() => {
                      setShowAddModal(false);
                      setIsEditMode(false);
                      setEditingId(null);
                      setFormData({
                        memo_no: "",
                        memo_date: "",
                        name_of_works: "",
                        boc: null,
                        alotment: "",
                        alotment_amount: "",
                        work_order_memo_no: "",
                        work_order_date: "",

                        engence_agency: "",
                        estimet_amount: "",
                        less_amount: "",
                        above_amount: "",
                        final_amount: "",

                        date_of_agreement: "",
                        duration: "",
                        date_of_commencement: "",
                        date_of_completion: "",
                        name_of_concerned_sae: "",
                        department_date: "",
                        department: "",
                        physical_status: "",
                        final_payment_amount: "",
                        unspent_balance: "",
                        remarks: "",
                      });
                    }}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary btn-sm">
                    {isEditMode ? "Update" : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {showStatusModal && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header" style={{ padding: "12px 20px" }}>
                <h5
                  className="modal-title"
                  style={{
                    color: "#2c3e50",
                    fontWeight: 500,
                    fontSize: "1.2rem",
                  }}
                >
                  Update Status for Memo No: {selectedMemoNo}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowStatusModal(false);
                    setStatusFormData({
                      date: "",
                      department: "",

                      //   type: "",
                    });
                  }}
                ></button>
              </div>

              <form onSubmit={handleStatusSubmit}>
                <div
                  className="modal-body"
                  style={{ padding: "18px 20px 10px 20px" }}
                >
                  <div className="container-fluid">
                    <div className="row g-2">
                      <div className="col-12">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Date
                        </label>
                        <input
                          type="date"
                          className="form-control form-control-sm mb-2"
                          name="date"
                          value={statusFormData.date}
                          onChange={handleStatusChange}
                          required
                        />
                      </div>
                      <div className="col-12">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Department
                        </label>
                        <select
                          className="form-select form-select-sm mb-2"
                          name="department"
                          value={statusFormData.department}
                          onChange={handleStatusChange}
                          required
                        >
                          <option value="">Select Department</option>
                          <option value="AE">AE</option>
                          <option value="FO">FO</option>
                          <option value="CM">CM</option>
                        </select>
                      </div>
                      {/* 
                      <div className="col-12">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Type
                        </label>
                        <select
                          className="form-select form-select-sm mb-2"
                          name="type"
                          value={statusFormData.type}
                          onChange={handleStatusChange}
                          required
                        >
                          <option value="">Select Type</option>
                          <option value="Received">Received</option>
                          <option value="Dispatch">Dispatch</option>
                        </select>
                      </div>
                       */}
                    </div>
                  </div>
                </div>
                <div className="modal-footer" style={{ padding: "10px 20px" }}>
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    onClick={() => {
                      setShowStatusModal(false);
                      setStatusFormData({
                        date: "",
                        department: "",
                        type: "",
                      });
                    }}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary btn-sm">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default PdfSection;
